import { Checkbox, ModalWindow, Div } from "@tblabs/truffle";
import { AppSettings } from '../Services/AppSettings';
import { Translations } from "../Translations/Translations";
import { PrimaryButton } from "../Components/General/Buttons/PrimaryButton";
import { Beepers } from "../Services/Beepers";


export class AppSettingsWindow extends ModalWindow
{
    constructor(_lang: Translations, _settings: AppSettings, _beepers: Beepers)
    {
        super(_lang.ApplicationSettings, true, false, true);

        this.AddContent(
            new Checkbox(_settings.Sounds, _lang.SoundsInApp),
            new Div().PaddingLeft(32).MarginTop(8).Style("display: flex; flex-direction: column; gap: 8px;")
                .Append(
                    new Checkbox(_settings.CameraConnectionSounds, _lang.CameraConnectionSound)
                        .Enable(_settings.Sounds)
                    // .Append(
                    //     new Svg(Icons.Sound).Color("#1e87f0").CursorPointer().OnClick(() => _beepers.MakeCameraConnection(true)),
                    //     new Svg(Icons.Sound).Color("#1e87f0").CursorPointer().OnClick(() => _beepers.MakeCameraConnection(false)),
                    // ),
                    ,
                    new Checkbox(_settings.NewPictureInLivePreviewMode, _lang.NewPictureInLivePreviewMode)
                        .Enable(_settings.Sounds)
                    // .Append(
                    //     new Svg(Icons.Sound).Color("#1e87f0").CursorPointer().OnClick(() => _beepers.MakeNewPictureSound(PreviewMode.LivePreview)),
                    // ),
                    ,
                    new Checkbox(_settings.NewPictureInSnapshotViewMode, _lang.NewPictureInSnapshotViewMode)
                        .Enable(_settings.Sounds)
                    // .Append(
                    //     new Svg(Icons.Sound).Color("#1e87f0").CursorPointer().OnClick(() => _beepers.MakeNewPictureSound(PreviewMode.SnapshotView)),
                    // ),
                    ,
                    new Checkbox(_settings.SensorsSounds, _lang.SensorsSounds)
                        .Enable(_settings.Sounds)
                ),
        );

        this.AddToFooter(
            new PrimaryButton(_lang.Close).OnClick(() => this.CloseWindow())
        );

        this.OpenWindow();
    }
}
